import api from "../../api/api";

export const getECDetails = async () => {
  return await api.get("getAllWebAppUsers");
};
